import { render, staticRenderFns } from "./VipIcon.vue?vue&type=template&id=56d9cb14"
import script from "./VipIcon.vue?vue&type=script&lang=js"
export * from "./VipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports